import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
//import Accordion from "react-bootstrap/Accordion";
import { CircularProgress } from "@material-ui/core";
import BackArrowicon from "../../images/BackArrowIcon.svg";
import activeModule from "../../images/activeModule.svg";
import inactiveModule from "../../images/inactiveModule.svg";
import plusAccordionIcon from "../../images/plusAccordioIcon.svg";
import minusAccordionIcon from "../../images/minusAccordionIcon.svg";
import "../../css/associatedModuleModal.scss";
import AssociateModuleCards from "../AssociatedModuleCards";
import CircularProgressBar from "../../utils/CircularProgressBar";
import {
  sendModuleCardtoEditor,
  updateModuleCardsinEditor,
} from "../../services/apis";
import ValueContext from "../../utils/contextAPI/contextAPI";

const AssociateModuleModal = (props) => {
  const {
    associatedModulecards,
    handleBackToModuleSearch,
    handleSelectNextModalHide,
    payloadObject,
    deckData,
    setShowAssociateModal,
    editModulelistFlag,
    setEditModulelistFlag,
    setLinkedModule,
    setLinkedMMModules,
    getVeevaLinkedmodules,
  } = props;
  const [isloading, setIsloading] = useState(false);
  const [showAssociatedList, setShowAssociatedList] = useState(false);
  const [moduleCode, setModuleCode] = useState("");
  const [moduleIndex, setModuleIndex] = useState(0);
  const [moduleData, setModuleData] = useState({});
  const [itemId, setItemId] = useState("");
  const [showMustExistWith, setShowMustExistWith] = useState(true);
  const [showRelatedModules, setShowRelatedModules] = useState(false);
  const [showPrecedesModules, setShowPrecedesModules] = useState(false);
  const [showSucceedsModules, setShowSucceedsModules] = useState(false);
  const [mustExistCountDeselect, setMustExistCount] = useState(0);
  const [checkboxSections, setCheckboxSections] = useState({});
  const [copyOriginalData, setCopyOriginalData] = useState([]);
  const [storedStatus, setStoredStatus] = useState({});
  const appData = useContext(ValueContext);
  let { pageId } = useParams();

  const expandAccordion = (event, accordionName) => {
    if (accordionName === "mustExistWith") {
      setShowRelatedModules(false);
      setShowMustExistWith(!showMustExistWith);
      setShowPrecedesModules(false);
      setShowSucceedsModules(false);
    } else if (accordionName === "relatedTo") {
      setShowRelatedModules(!showRelatedModules);
      setShowMustExistWith(false);
      setShowPrecedesModules(false);
      setShowSucceedsModules(false);
    } else if (accordionName === "precedes") {
      setShowRelatedModules(false);
      setShowMustExistWith(false);
      setShowPrecedesModules(!showPrecedesModules);
      setShowSucceedsModules(false);
    } else if (accordionName === "succeeds") {
      setShowRelatedModules(false);
      setShowMustExistWith(false);
      setShowPrecedesModules(false);
      setShowSucceedsModules(!showSucceedsModules);
    }
  };
  const openAssociatedModule = (modulecode, index, list) => {

    const sections = ["mustExistWith", "relatedTo", "precedes", "succeeds"];
    const ar = {};
    if (JSON.stringify(list) !== "{}") {
      for (var i = 0; i < sections.length; i++) {
        const obj = {};
        for (var j = 0; j < list[sections[i]].length; j++) {
          obj[list[sections[i]][j].moduleId] =
            sections[i] !== "relatedTo" ? true : false;
        }
        ar[sections[i]] = obj;
      }
    }
    const storedObj = {};
    storedObj[modulecode] = ar;

    if (!storedStatus.hasOwnProperty(modulecode)) {
      setCheckboxSections({ ...ar });
      setStoredStatus({ ...storedStatus, ...storedObj });
    } else {
      setCheckboxSections({ ...storedStatus[modulecode] });
    }

    setShowRelatedModules(false);
    setShowPrecedesModules(false);
    setShowSucceedsModules(false);
    setModuleCode(modulecode);
    setShowAssociatedList(true);
    setModuleIndex(index);
    setModuleData(list);
    setShowMustExistWith(true);
  };

  const defaultExpand = () => {
    setIsloading(true);
    const firstModule = associatedModulecards
      ? associatedModulecards[0]?.moduleCode
      : "";
    openAssociatedModule(
      firstModule,
      moduleIndex,
      associatedModulecards[moduleIndex]
    );
    setIsloading(false);
  };

  const onPreviousModuleButtonClick = () => {
    openAssociatedModule(
      associatedModulecards[moduleIndex - 1].moduleCode,
      moduleIndex - 1,
      associatedModulecards[moduleIndex - 1]
    );
  };

  const onNextModuleButtonClick = () => {
    openAssociatedModule(
      associatedModulecards[moduleIndex + 1].moduleCode,
      moduleIndex + 1,
      associatedModulecards[moduleIndex + 1]
    );
  };

  const handleSelectedCheckboxes = (event, id, section, item) => {
    const sectionData = checkboxSections[section];
    sectionData[id] = !sectionData[id];
    if (section === "mustExistWith") {
      if (sectionData[id] == false && mustExistCountDeselect >= 0) {
        setMustExistCount(mustExistCountDeselect + 1);
      } else {
        setMustExistCount(mustExistCountDeselect - 1);
      }
    }
    const copyData = checkboxSections;
    copyData[section] = sectionData;
    setCheckboxSections({ ...copyData });
    // console.log(
    //   "logggggggggggggggggggggg",
    //   copyData,
    //   id,
    //   moduleData.moduleCode,
    //   moduleData?.mustExistWith
    // );

    const copyStoredSTatus = storedStatus;
    copyStoredSTatus[moduleData.moduleCode] = copyData;
    setStoredStatus({ ...copyStoredSTatus });
   // console.log("storeddddddddd", storedStatus);

    //filterout payload
    const deepCopy = JSON.parse(JSON.stringify(copyOriginalData));
    const copyModuleData = deepCopy?.filter(
      (module) => module.moduleCode === moduleData.moduleCode
    );
    const sectionUpdate = JSON.parse(
      JSON.stringify(copyModuleData[0][section])
    );
    if (sectionUpdate.length > 0) {
      for (var i = 0; i < sectionUpdate.length; i++) {
        if (
          sectionUpdate.length > 0 &&
          sectionData[sectionUpdate[i].moduleId] === true &&
          sectionData[id] === true
        ) {
          // copyModuleData[0][section].splice(i, 1, item);
          copyModuleData[0][section].push(item);
        } else if (sectionUpdate.length == 0 && sectionData[id] === true) {
          // copyModuleData[0][section].splice(i, 1, item);
          copyModuleData[0][section].push(item);
        } else {
          const filter = copyModuleData[0][section].filter(
            (data) => sectionData[data.moduleId] === true
          );
          copyModuleData[0][section] = filter;
        }
      }
    } else {
      if (sectionUpdate.length == 0 && sectionData[id] === true) {
        copyModuleData[0][section].push(item);
      }
    }
    const updateData = JSON.parse(JSON.stringify(copyOriginalData));
    for (var i = 0; i < updateData.length; i++) {
      if (updateData[i].moduleId === moduleData.moduleId) {
        updateData.splice(i, 1, copyModuleData[0]);
      }
    }
    setCopyOriginalData([...updateData]);
   // console.log("after update", updateData);
    //setCopyOriginalData()
    //console.log("section data update", copyModuleData, sectionUpdate);
  };

  const handleProceed = () => {
    const payload = {
      deckid: deckData._id,
      slideid: pageId,
      module_type: "NEXT",
      moduleBusinessRules: [...copyOriginalData],
      search_expression: { ...payloadObject },
    };
    appData.deckId.module_type = "NEXT";

    if (editModulelistFlag) {
      updateModuleCardsinEditor(
        deckData._id,
        pageId,
        payload,
        (response, err, errorCode) => {
          if (err) {
            // const errCoponent = errComponentToRender(errorCode);
            console.log(err);
            setIsloading(false);
          } else {
            let resp = response.data;
            let data = response.data.content_modules;
            setIsloading(false);
            handleSelectNextModalHide();
            setShowAssociateModal(false);
            setEditModulelistFlag(false);
            setLinkedModule("");
            setLinkedMMModules(data);

            let IDRef =
              JSON.stringify(props.slideID.child) === "{}"
                ? props.slideID.master?.slideid?._id
                : props.slideID.child?.slideid?._id;
            getVeevaLinkedmodules(IDRef);
            // props.getVeevaLinkedmodules(IDRef);
          }
        }
      );
    } else {
      sendModuleCardtoEditor(payload, (response, err, errorCode) => {
        if (err) {
          // const errCoponent = errComponentToRender(errorCode);
          console.log(err);
          setIsloading(false);
        } else {
          let resp = response.data;
          setIsloading(false);
          handleSelectNextModalHide();
          setShowAssociateModal(false);
          let IDRef =
            JSON.stringify(props.slideID.child) === "{}"
              ? props.slideID.master?.slideid?._id
              : props.slideID.child?.slideid?._id;
          props.getVeevaLinkedmodules(IDRef);
        }
      });
    }
  };

  useEffect(() => {
    defaultExpand();

    const formatRelatedTo = JSON.parse(JSON.stringify(associatedModulecards));
    // const dataR = formatRelatedTo.map((update) => { update["relatedTo"] = []; return update; });
    const dataR = formatRelatedTo.map((update) => {
      update["relatedTo"] = [];
      delete update["genericInformation"];
      delete update["other"];
      delete update["standalone"];
      return update;
    });
    const deepCopy = JSON.parse(
      JSON.stringify(copyOriginalData.length > 0 ? copyOriginalData : dataR)
    );
    setCopyOriginalData([...deepCopy]);
  }, []);

  return (
    <div>
      <div className="row mt-4 red">
        <div className="col-md-12 moduleManagerTitle">
          <div>
            <img
              alt=""
              src={BackArrowicon}
              style={{ marginTop: "-3px", cursor: "pointer" }}
              onClick={handleBackToModuleSearch}
            />
            <span>SELECT ASSOCIATED MODULES</span>
          </div>
        </div>
      </div>
      {isloading && (
        <CircularProgressBar
          isloading={isloading}
          setIsloading={setIsloading}
        />
      )}
      <div className="row middleContent">
        <div className="col-md-2 middleContentLeft">
          <div className="leftScrollbar">
            {associatedModulecards?.map((list, index) => (
              <div
                key={index}
                className={`moduleCodeList ${
                  list["moduleCode"] == moduleCode
                    ? "moduleCodeClicked"
                    : "moduleCodeNotClicked"
                }`}
                onClick={() =>
                  openAssociatedModule(list["moduleCode"], index, list)
                }
              >
                <div className={`moduleCode`}>
                  <img
                    src={
                      list["moduleCode"] == moduleCode
                        ? activeModule
                        : inactiveModule
                    }
                  />
                  {list["moduleCode"]}
                </div>
                {list &&
                  (list["moduleCode"] == moduleCode
                    ? showAssociatedList
                    : false) && (
                    <ul>
                      {[
                        ...list["mustExistWith"],
                        ...list["relatedTo"],
                        ...list["precedes"],
                        ...list["succeeds"],
                      ]?.map((pre, ind) => (
                        <li key={ind}>{pre["moduleCode"]}</li>
                      ))}
                    </ul>
                  )}
              </div>
            ))}
          </div>
        </div>
        <div className="col-md-10 middleContentRight">
          <div
            className="row align-items-center mb-3 moduleNameDiv "
            style={{ marginLeft: "12px" }}
          >
            <div className="col-md-2">
              <span className="associatedBsModuleSubtitle">Module Name</span>
              <p className="associatedBsModuleSubText ">
                {moduleData.moduleName}
              </p>
            </div>
            <div className="col-md-5">
              <span className="associatedBsModuleSubtitle">Campaign Name</span>
              <p className="associatedBsModuleSubText">
                {moduleData.campaignName}
              </p>
            </div>
            <div className="col-md-5 text-end">
              <button
                onClick={onPreviousModuleButtonClick}
                disabled={moduleIndex <= 0 ? true : false}
                // className={`btn btn-outline btnPrevModule btn-lg ${moduleIndex < 0 ? 'activeBtn' : 'inactiveBtn'}`}
                // disabled={BIndex <= 0}
                className={
                  moduleIndex <= 0
                    ? "btn  btn-lg  btnPrevModule inactiveBtn"
                    : "btn btn-outline   btnPrevModule btn-lg activeBtn"
                }
              >
                PREVIOUS MODULE
              </button>

              <button
                onClick={onNextModuleButtonClick}
                /*  disabled={
                                     BIndex === veevaRules?.length - 1
                                     //checkModuleIndex("last")
                                 } */
                disabled={
                  moduleIndex === associatedModulecards.length - 1
                    ? true
                    : false
                }
                style={{ marginLeft: "24px" }}
                className={`btn btn-outline btnNextModule btn-lg mr-24 ${
                  moduleIndex >= 0 ? "activeBtn" : "inactiveBtn"
                }`}
              >
                NEXT MODULE
              </button>
            </div>
          </div>
          <hr style={{ width: "100%" }} />
          <div className="associativeCategories">
            <div className="categName">
              {/* must exist with accordion */}
              <div className="mustexistwith">
                <div
                  className="accordion-titlename"
                  onClick={(e) => expandAccordion(e, "mustExistWith")}
                >
                  <img
                    src={
                      showMustExistWith &&
                      moduleData["mustExistWith"]?.length > 0
                        ? minusAccordionIcon
                        : plusAccordionIcon
                    }
                  ></img>{" "}
                  {`Must Exist with (${
                    moduleData["mustExistWith"]?.length < 10
                      ? "0" + moduleData["mustExistWith"]?.length
                      : moduleData["mustExistWith"]?.length
                  })`}
                </div>
                <div className="row cardsRow">
                  {showMustExistWith &&
                    moduleData["mustExistWith"] &&
                    moduleData["mustExistWith"]?.map((items, index) => {
                      return (
                        <div className="col-md-6 next-card" key={index}>
                          <AssociateModuleCards
                            items={items}
                            cardCheck="mustExistWith"
                            handleSelectedCheckboxes={handleSelectedCheckboxes}
                            itemId={itemId}
                            checkboxSections={checkboxSections["mustExistWith"]}
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
              {/* Precedes Modules with accordion */}
              <div className="mustexistwith">
                <div
                  className="accordion-titlename"
                  onClick={(e) => expandAccordion(e, "precedes")}
                >
                  <img
                    src={
                      showPrecedesModules && moduleData["precedes"].length > 0
                        ? minusAccordionIcon
                        : plusAccordionIcon
                    }
                  ></img>{" "}
                  {`Precedes (${
                    moduleData["precedes"]?.length < 10
                      ? "0" + moduleData["precedes"]?.length
                      : moduleData["precedes"]?.length
                  })`}
                </div>
                <div className="row cardsRow">
                  {showPrecedesModules &&
                    moduleData["precedes"] &&
                    moduleData["precedes"]?.map((items, index) => {
                      return (
                        <div className="col-md-6 next-card" key={index}>
                          <AssociateModuleCards
                            items={items}
                            cardCheck="precedes"
                            handleSelectedCheckboxes={handleSelectedCheckboxes}
                            itemId={itemId}
                            checkboxSections={checkboxSections["precedes"]}
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
              {/* Succeeds Modules with accordion */}
              <div className="mustexistwith">
                <div
                  className="accordion-titlename"
                  onClick={(e) => expandAccordion(e, "succeeds")}
                >
                  <img
                    src={
                      showSucceedsModules && moduleData["succeeds"].length > 0
                        ? minusAccordionIcon
                        : plusAccordionIcon
                    }
                  ></img>{" "}
                  {`Succeeds (${
                    moduleData["succeeds"]?.length < 10
                      ? "0" + moduleData["succeeds"]?.length
                      : moduleData["succeeds"]?.length
                  })`}
                </div>
                <div className="row cardsRow">
                  {showSucceedsModules &&
                    moduleData["succeeds"] &&
                    moduleData["succeeds"]?.map((items, index) => {
                      return (
                        <div className="col-md-6 next-card" key={index}>
                          <AssociateModuleCards
                            items={items}
                            cardCheck="succeeds"
                            handleSelectedCheckboxes={handleSelectedCheckboxes}
                            itemId={itemId}
                            checkboxSections={checkboxSections["succeeds"]}
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
              {/* Related Modules with accordion */}
              <div className="mustexistwith">
                <div
                  className="accordion-titlename"
                  onClick={(e) => expandAccordion(e, "relatedTo")}
                >
                  <img
                    src={
                      showRelatedModules && moduleData["relatedTo"].length > 0
                        ? minusAccordionIcon
                        : plusAccordionIcon
                    }
                  ></img>{" "}
                  {`Related Modules (${
                    moduleData["relatedTo"]?.length < 10
                      ? "0" + moduleData["relatedTo"]?.length
                      : moduleData["relatedTo"]?.length
                  })`}
                </div>
                <div className="row cardsRow">
                  {showRelatedModules &&
                    moduleData["relatedTo"] &&
                    moduleData["relatedTo"]?.map((items, index) => {
                      return (
                        <div className="col-md-6 next-card" key={index}>
                          <AssociateModuleCards
                            items={items}
                            cardCheck="relatedTo"
                            handleSelectedCheckboxes={handleSelectedCheckboxes}
                            itemId={itemId}
                            checkboxSections={checkboxSections["relatedTo"]}
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row searhModalFooterRow align-items-center moduleFooter">
        <div className="col-md-6 deselect-mustExist">
          {mustExistCountDeselect > 0 &&
            mustExistCountDeselect +
              " Must exist Modules Deselected. This can result in compliance issues"}
        </div>
        <div className="col-md-6 text-end">
          <button
            className="btn btn-link searchLinkBtn"
            onClick={() => {
              handleSelectNextModalHide();
              setShowAssociateModal(false);
            }}
          >
            CANCEL
          </button>
          <button
            className="proceed-btn btn btn-default "
            onClick={handleProceed}
            disabled={false}
          >
            PROCEED
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssociateModuleModal;
